// extracted by mini-css-extract-plugin
module.exports =  {"fact__additional":"da51a739f7--fact__additional--NwrJB","horizontal":"da51a739f7--horizontal--dj_L5","fact":"da51a739f7--fact--yPHrZ","vertical":"da51a739f7--vertical--Xka5B"};